<div class="container-fluid sell_dash">
    <div class="wrapper">
        <div class="row">
          <app-sidemenu></app-sidemenu> 
          <section class="right">
              <app-sellheader></app-sellheader>
              <div class="right-middle row justify-content-center">
               <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                    <div class="kt-portlet">
                        <div class="kt-portlet__body kt-portlet__body--fit">
                            <div class="kt-invoice-1">
                                <div class="kt-invoice__head">
                                    <div class="kt-invoice__container">
                                        <div class="kt-invoice__brand">
                                            <h1 class="kt-invoice__title">INVOICE</h1>
                                            <div href="#" class="kt-invoice__logo">
                                                <a href="#"><img src="./assets/image/logo_client_white.png"></a>
                                                <span class="kt-invoice__desc">
                                                    <span>DATAPITCHER</span>
                                                    <span>Subscription Plan</span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="kt-invoice__items">
                                            <div class="kt-invoice__item">
                                                <span class="kt-invoice__subtitle">YEAR OF ENGAGEMENT</span>
                                                <span class="kt-invoice__text">2020</span>
                                            </div>
                                            <div class="kt-invoice__item">
                                                <span class="kt-invoice__subtitle">INVOICE NO.</span>
                                                <span class="kt-invoice__text">DP 000014</span>
                                            </div>
                                            <div class="kt-invoice__item">
                                                <span class="kt-invoice__subtitle">INVOICE By.</span>
                                                <span class="kt-invoice__text">DataPitcher, TBDC, 1 Yonge Street, Suite 900 Toronto, ON M5E 1E5</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="kt-invoice__body">
                                    <div class="kt-invoice__container">
                                        <div class="table-responsive">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th>DESCRIPTION</th>
                                                        <th>FEATURES</th>
                                                        <th>RATE</th>
                                                        <th>AMOUNT</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Free Subscription</td>
                                                        <td>FULL PACK</td>
                                                        <td>$0.00</td>
                                                        <td>$0.00</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="kt-invoice__footer">
                                    <div class="kt-invoice__container">
                                        <div class="kt-invoice__bank">
                                            <div class="kt-invoice__title">BANK TRANSFER</div>
                                            <div class="kt-invoice__item">
                                                <span class="kt-invoice__label">Account Name:</span>
                                                <span class="kt-invoice__value">RG SMARTDISCOVERY LLP</span>
                                            </div>
                                            <div class="kt-invoice__item">
                                                <span class="kt-invoice__label">Account Number:</span>
                                                <span class="kt-invoice__value">914020027236794</span>
                                            </div>
                                            <div class="kt-invoice__item">
                                                <span class="kt-invoice__label">Code:</span>
                                                <span class="kt-invoice__value">UTIB0000371</span>
                                            </div>
                                        </div>
                                        <div class="kt-invoice__total">
                                            <span class="kt-invoice__title">TOTAL AMOUNT</span>
                                            <span class="kt-invoice__price">$0.00</span>
                                            <span class="kt-invoice__notice">Taxes Included</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="kt-invoice__actions">
                                    <div class="kt-invoice__container">
                                        <button type="button" class="btn btn-label-brand btn-bold" onclick="window.print();">Download Invoice</button>
                                        <button type="button" class="btn btn-brand btn-bold" onclick="window.print();">Print Invoice</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>
            </div>
        </section>  
          <!-- begin::Sticky Toolbar -->
          <app-stickytoolbar></app-stickytoolbar>
          <!-- end::Sticky Toolbar -->       
       </div>
    </div>
</div>

